import { useMsal } from "@azure/msal-react";
import { useEffect, useMemo, useState } from "react";
import { getAuthConfig } from "./authConfig";

export const useLogout = (): (() => void) => {
  const { instance, accounts } = useMsal();
  const homeAccountIdLatest = useMemo(() => (accounts[0] || {}).homeAccountId, [accounts]);
  const [homeAccountId, setHomeAccountId] = useState<string | undefined>(homeAccountIdLatest);

  useEffect(() => {
    if (homeAccountIdLatest) {
      setHomeAccountId(homeAccountIdLatest);
    }
  }, [homeAccountIdLatest]);

  const onLogout = async () => {
    if (!homeAccountId) return;
    const logoutRequest = {
      account: instance.getAccountByHomeId(homeAccountId),
      postLogoutRedirectUri: getAuthConfig().MSAL_LOGOUT_REDIRECT,
    };
    instance.logoutRedirect(logoutRequest);
  };
  return onLogout;
};
